/**
 * Meta keywords merged into every route via `buildPageMetadata` and the root layout.
 * Phrases align with on-site services and common local search intent.
 */
export const sharedMetadataKeywords: readonly string[] = [
   'Clean Park',
   'Clean Park Morrinsville',
   'Morrinsville car wash',
   'Waikato car wash',
   '42 Studholme Street Morrinsville',
   'Yello K Wash Morrinsville',
   '24 hour car wash Morrinsville',
   '24/7 car wash Morrinsville',
   'automatic car wash Morrinsville',
   'self serve car wash Morrinsville',
   'self serve wash bays Morrinsville',
   'drive through car wash Morrinsville',
   'touchless car wash Morrinsville',
   'high pressure car wash Morrinsville',
   'foam brush car wash',
   'pre soak car wash',
   'triple foam car wash Morrinsville',
   'car wax wash Morrinsville',
   'tyre cleaner wash bay',
   'degreaser car wash Morrinsville',
   'tall vehicle car wash Morrinsville',
   '2.8m car wash Morrinsville',
   'vacuum station Morrinsville',
   'interior vacuum Morrinsville',
   'dog wash Morrinsville',
   'self serve dog wash Morrinsville',
   'pet wash Morrinsville',
   'vehicle detailing Morrinsville',
   'vehicle grooming Morrinsville',
   'car detailing Morrinsville',
   'interior detailing Morrinsville',
   'exterior detailing Morrinsville',
   'car valet Morrinsville',
   'cut and polish Morrinsville',
   'paint correction Morrinsville',
   'machine polish Morrinsville',
   'Seat and carpet shampoo',
   'Stain removal',
   'Water spot removal',
   'Tractors RVs and boats',
   'tractor wash Morrinsville',
   'RV wash Morrinsville',
   'boat wash Morrinsville',
   'large vehicle wash Morrinsville',
   'Engine bay cleaning',
   'fleet wash Morrinsville',
   'fleet car wash account Waikato',
   'business car wash Morrinsville',
   'Matamata car wash nearby',
   'Hamilton car wash nearby',
   'Waikato vehicle wash',
   'Te Aroha dog wash nearby',
   'Cambridge Waikato car grooming',
   'NZ pet wash 24 hour',
   'Waikato fleet car wash business',
   'NZ commercial vehicle wash account',
   'farm fleet wash Waikato',
   'tradie wash account Morrinsville',
   'monthly fleet invoice car wash',
   'car grooming near Hamilton',
   'vehicle shampoo Morrinsville',
   'interior car groom Waikato',
   'auto detailing booking Morrinsville'
]
